import React from "react";
import { Modal, Form, Input, Select, Space } from "antd";

export const DriverFilter = ({
  form,
  isModalOpen,
  handleCancel,
  setFilterForm,
  filterForm,
  handleFilter,
  vendorList,
}) => {
  return (
    <Modal
      title="Filters"
      open={isModalOpen}
      onOk={handleFilter}
      okText="Filter Data"
      onCancel={handleCancel}
    >
      <Form form={form} layout="vertical">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <Form.Item name="name" className="subscription-plan">
            <Input
              value={filterForm?.name}
              onChange={(e) =>
                setFilterForm({ ...filterForm, name: e.target.value })
              }
              size="large"
              placeholder="Filter by Name"
            />
          </Form.Item>
          <Form.Item name="mobile" className="subscription-plan">
            <Input
              value={filterForm?.mobile}
              onChange={(e) =>
                setFilterForm({ ...filterForm, mobile: e.target.value })
              }
              size="large"
              placeholder="Filter by Mobile"
            />
          </Form.Item>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <Form.Item name="ownerId" className="subscription-plan">
            <Select
              value={filterForm?.ownerId}
              onChange={(value) =>
                setFilterForm({ ...filterForm, ownerId: value })
              }
              placeholder="Filter by Vendor"
              style={{ width: "100%" }}
            >
              {vendorList?.length > 0 ? (
                vendorList.map((vendor) => (
                  <Select.Option key={vendor.id} value={vendor.id}>
                    {vendor.fullName}
                  </Select.Option>
                ))
              ) : (
                <Select.Option value="default">Loading...</Select.Option>
              )}
            </Select>
          </Form.Item>
          <Form.Item name="isActive" className="subscription-plan">
            <Select
              value={filterForm?.isActive}
              onChange={(value) =>
                setFilterForm({ ...filterForm, isActive: value })
              }
              placeholder="Filter by Status"
              style={{ width: "100%" }}
              options={[
                { value: "false", label: "Inactive" },
                { value: "true", label: "Active" },
              ]}
            />
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};
